import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ReverseGeocode'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ReverseGeocodeStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ReverseGeocodeStore",
			variables: true,
		})
	}
}

export async function load_ReverseGeocode(params) {
  await initClient()

	const store = new ReverseGeocodeStore()

	await store.fetch(params)

	return {
		ReverseGeocode: store,
	}
}
